import React, { useState, forwardRef } from "react";
import "./TextInput.css";

interface TextInputProps {
  iconPath?: string;
  placeholder?: string;
  onSubmit?: (message: string) => void;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ iconPath = "", placeholder = "", onSubmit }, ref) => {
    const [value, setValue] = useState("");

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter" && value.trim()) {
        onSubmit?.(value.trim());
        setValue("");
      }
    };

    return (
      <div className="text-input-bar">
        <img src={iconPath} alt="Input icon" />
        <input
          ref={ref}
          type="text"
          className="text-input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    );
  }
);

export default TextInput;
